import React from "react";
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { fieldSx, SHIP_BY_OPTIONS } from "./bottleOrderFormHelpers";

const ShippingDetailsStep = ({ formData, handleChange }) => (
    <>
        <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6} md={3}>
                <TextField fullWidth size="small" variant="outlined" label="Shipping Date" type="date"
                    value={formData.shippingDate} onChange={handleChange("shippingDate")}
                    InputLabelProps={{ shrink: true }} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <TextField fullWidth size="small" variant="outlined" label="Date Received" type="date"
                    value={formData.dateReceived} onChange={handleChange("dateReceived")}
                    InputLabelProps={{ shrink: true }} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <TextField fullWidth size="small" variant="outlined" label="Tracking Number"
                    value={formData.trackingNumber} onChange={handleChange("trackingNumber")} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <FormControl variant="outlined" fullWidth size="small" sx={fieldSx}>
                    <InputLabel>Ship By</InputLabel>
                    <Select
                        value={(formData.shipBy || "").trim()}
                        label="Ship By"
                        onChange={handleChange("shipBy")}
                    >
                        <MenuItem value=""><em>Select Shipping Method</em></MenuItem>
                        {SHIP_BY_OPTIONS.map((v) => <MenuItem key={v} value={v}>{v}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>

        <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
                <TextField fullWidth size="small" variant="outlined" label="Internal Tracking Comments"
                    value={formData.trackingComment} onChange={handleChange("trackingComment")}
                    multiline rows={3} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField fullWidth size="small" variant="outlined" label="Shipping Instructions"
                    value={formData.shippingInstructions} onChange={handleChange("shippingInstructions")}
                    multiline rows={3} sx={fieldSx} />
            </Grid>
        </Grid>
    </>
);

export default ShippingDetailsStep;
